import { memo } from 'react'

import UserEducationModal from './UserEducationModal'

const UserEducationModalComponent = memo(UserEducationModal)

export default UserEducationModalComponent
